import { Link } from "react-router-dom";
import { Seo } from "../../components/Seo";

export function NotFound() {
  return (
    <>
      <Seo title="Page introuvable" path="/404" />
      <section className="section">
        <div className="container-narrow text-center">
          <h1 className="h-hero">404</h1>
          <p className="mt-4 text-ink-500">Cette page n'existe pas ou a été déplacée.</p>
          <Link to="/" className="btn-primary mt-6">Retour à l'accueil</Link>
        </div>
      </section>
    </>
  );
}
